import React from 'react'
import { connect, } from 'react-redux';
import { Component } from 'react';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { withRouter } from '../withRouter';
import FormAlert from './FormAlert';
import styles from '../Forms/FormStyles.module.scss';
import AuthService from 'services/auth';
import DotLoader from 'components/Utlility/DotLoader';

class ResetPIN extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pin: '',
            confirmPin: '',
            input: {},
            errors: {},
            type: 'password',
            loading: false,
            message: '',
            successful: false,
        }

        this.validate = this.validate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleResetPIN = this.handleResetPIN.bind(this);
        this.showHide = this.showHide.bind(this);

        this.target = React.createRef();
    }

    componentDidMount = () => {
        if (!this.props.auth.user.roomPin) {
            this.props.navigate("/");
        }
    }


    handleChange(event) {
        if (this.state.loading) return;

        const target = event.target;
        const value = target.value;
        const name = target.name;

        let input = this.state.input;
        input[event.target.name] = event.target.value;

        const pin = input["pin"];
        const validLength = pin.length >= 4;

        this.setState({
            [name]: value, input, validLength, 
        });

        this.validate();
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["pin"]) {
            isValid = false;
            errors["pin"] = "Please enter a new pin.";
        }

        if (!input["confirmPin"]) {
            isValid = false;
            errors["confirmPin"] = "Please ensure your new pin and confirmation pin match.";
        }

        if (typeof input["pin"] !== "undefined" && typeof input["confirmPin"] !== "undefined") {

            if (input["pin"] !== input["confirmPin"]) {
                isValid = false;
                errors["pin"] = "PINs don't match.";
            }
            else {
                if (input["pin"].length < 4) {
                    isValid = false;
                    errors["pin"] = "PIN length not met.";
                }
                else {
                    isValid = true;
                    errors["pin"] = "";
                }
            }
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    handleResetPIN = event => {
        event.preventDefault();

        if (this.validate()) {
            this.setState({
                loading: true
            });

            AuthService.resetPIN(this.state.pin, this.state.confirmPin).then((response) => {
                console.log("reset pIN response : ", response);
                let message = response.message || response.message.toString();
                if (response.Status === "Success" && this.props.room.roomOpen) {
                    this.props.room.room.send("update_pin", { pin: this.state.pin });
                }
                this.setState({
                    message: message,
                    successful: true,
                    loading: false
                });
            }, (error) => {
                console.log("reset pw error : ", error);
                const messageError = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                this.setState({
                    message: messageError,
                    successful: false,
                    loading: false
                });
            });
        }
    }

    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type === 'input' ? 'pin' : 'input'
        })
    }

    render() {
        return (
            <Form id="resetPINForm" onSubmit={this.handleResetPIN}>
                <h2 className={styles.formTitle}>Reset PIN</h2>
                {this.state.successful ?
                    <>
                        {this.state.message && (
                            <Form.Group>
                                <FormAlert variant={this.state.successful ? "success" : "danger"}>{this.state.message}</FormAlert>
                            </Form.Group>
                        )}
                    </>
                    :
                    <>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                New PIN
                            </Form.Label>
                            <Form.Control
                                type={this.state.type}
                                autoComplete="off"
                                id="pin"
                                name="pin"
                                value={this.state.pin}
                                onChange={this.handleChange}
                                isInvalid={!this.state.validLength }
                                required
                                disabled={this.state.successful}
                            />
                            <FormAlert variant="danger">{this.state.errors.pin}</FormAlert>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Confirm New PIN
                            </Form.Label>
                            <Form.Control
                                type={this.state.type}
                                autoComplete="off"
                                id="confirmPin"
                                name="confirmPin"
                                value={this.state.confirmPin}
                                onChange={this.handleChange}
                                required
                                disabled={this.state.successful}
                            />
                            <FormAlert variant="danger">{this.state.errors.confirmPin}</FormAlert>
                       

                        </Form.Group>
                        <Form.Group>
                            <ul className={styles.passwordRequirements}>
                                <li className={this.state.validLength ? "text-success" : "text-danger"}>
                                    Your pin must be at least 4 characters
                                </li>
                                {/*<li className={this.state.hasNumber ? "text-success" : "text-danger"}>*/}
                                {/*    Your password must include a number*/}
                                {/*</li>*/}
                                {/*<li className={this.state.upperCase ? "text-success" : "text-danger"}>*/}
                                {/*    Your password must include an upper case letter*/}
                                {/*</li>*/}
                                {/*<li className={this.state.lowerCase ? "text-success" : "text-danger"}>*/}
                                {/*    Your password must include a lower case letter*/}
                                {/*</li>*/}
                            </ul>
                        </Form.Group>

                        {this.state.message && (
                            <Form.Group>
                                <FormAlert variant={this.state.successful ? "success" : "danger"}>{this.state.message}</FormAlert>
                            </Form.Group>
                        )}

                        {!this.state.successful &&
                            <Form.Group>
                                <button type="submit" className={styles.button} disabled={this.state.loading}>
                                {this.state.loading && (
                                        <DotLoader size="medium" variant="light" />
                                    )}
                                    Submit
                                </button>
                        </Form.Group>
                        }

                    </>
                }
                {/*{this.state.successful &&*/}
                {/*    <Form.Group>*/}
                {/*        <button type="button" onClick={() => this.props.navigate("/login")} className={styles.button}>Login into account</button>*/}
                {/*    </Form.Group>*/}
                {/*}*/}
            </Form>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

export default connect(mapStateToProps, null)(withRouter(ResetPIN));